/*Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Heading,
  InfoDisplay,
  Select
} from '../../'

import { default as CurrentAddresses } from './CurrentAddresses'
import { default as ArchivedAddresses } from './ArchivedAddresses'


class IdentityAddresses extends React.Component {
  static propTypes = {
    identity: PropTypes.object.isRequired,
    onActionSuccess: PropTypes.func.isRequired,
    onAddressSave: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  state = {
    archivedView: false
  }

  restoreAddress = (addressId) => {
    let input = {
      id: addressId,
      inactive: false
    }

    this.props.saveAddress({ variables: { input } })
      .then(() => {
        console.log('Address restored from archive successfully')
        this.props.onAddressSave()
      })
      .catch((error) => {
        console.log('Restoring address from archive failed.', error)
      })
  }

  render() {
    let { identity, onActionSuccess } = this.props

    return (
      <div className={this.props.className}>
        <Heading marginBottom={3}>
          Addresses
        </Heading>
        <div className='slds-m-top_small slds-m-bottom_large slds-grid'>
          <span className='slds-m-top_xx-small'>
            Show:
          </span>
          <Select
            value={this.state.archivedView ? 'Archive' : 'Current'}
            options={['Current', 'Archive']}
            onChange={e => this.setState({ archivedView: e.target.value === 'Archive' })}
            className='slds-m-left_x-small'
            minWidth={150}
          />
        </div>
        {this.state.archivedView
          ? <InfoDisplay
              rows={
                <ArchivedAddresses
                  identityAddresses={identity.addresses}
                  onRestoreAddressClick={this.restoreAddress}
                />
              }
              noButtons={true}
              className='slds-m-bottom_x-large'
            />
          : <CurrentAddresses
              identityId={identity.id}
              identityFirstName={identity.firstName}
              identityAddresses={identity.addresses}
              onActionSuccess={onActionSuccess}
            />
        }
      </div>
    )
  }
}

const saveAddress = gql`
  mutation saveAddress($input: AddressMutationInput!) {
    addressMutate(input: $input) {
      address {
        id
        identity {
          id
        }
        addressType
        addressValue
        default
        inactive
        optedOut
      }
    }
  }
`

const withAddressMutate =
  graphql(saveAddress, {
    name: 'saveAddress'
  })

export default withAddressMutate(IdentityAddresses)



// WEBPACK FOOTER //
// ./src/components/messageplus/employee-contact-details/IdentityAddresses.js